import Vue from "vue";
import Vuex from "vuex";
import mutations from "./mutations";
import actions from "./actions";
Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    widthCards: "80%",
    dataModalDialogGeneral: {
      nameModal: "",
      title: "",
      subTitle: "",
      footerTitle: "",
      leftButtonText: "",
      rightButtonText: "",
    },
    dataConfig: {
      id: null,
      caixa_automatico: {
        idResponsavel: null,
        utilizar: false,
        valorInicial: 0.0,
        horaAbertura: null,
        horaFechamento: null,
      },
    },
    dataCompany: {},
    navItemSelected: "",
    sizeModalBigBox: "disable",
    sizeModal: "disable",
    sizeModalRegister: "disable",
    dataSearchCourse: {},
    CourseIdToSaleOrOrder: null,
    htmlToPrint: '',
    colapseBigBox: false,
    colapseGeneral: false,
    colapseRegister: false,
    isSearchRegisters: false,
    colapsePrint: false,
    modalContainer: "contentModalDisable",
    modalContainerGeneral: "contentModalDisable",
    remainingValue: null,
    typeRegister: {
      course: false,
      detailsCourse: false,
    },
    overflow: "auto",
  },
  actions,
  mutations,
});
export default store;
